/**
 * 定义 mutation 里用到的方法常量值，统一处理在这里，一般都是业务字符串常量
 * @author yangkun-QQ-58740563-foxkeeper-yangkun@xforceplus.com
 * @link
 * @create 2018-03-15
 */

//测试用
export var DEMO_TEST = 'DEMO_TEST'

export var ADD_TO_CART = 'ADD_TO_CART'
export var TOGGLE_STATUS = 'TOGGLE_STATUS'
export var DELETE_PRODUCT = 'DELETE_PRODUCT'
export var ADD_PRODUCT = 'ADD_PRODUCT'
export var CUT_PRODUCT = 'CUT_PRODUCT'
export var TOGGLE_ALLCHEK = 'TOGGLE_ALLCHEK'
export var UPDATE_ADDRESS = 'UPDATE_ADDRESS'
export var PLACE_ORDER = 'PLACE_ORDER'

//更新用户信息
export var UPDATE_USERINFO = 'UPDATE_USERINFO'

//更新banner标题
export var UPDATE_TITLE = 'UPDATE_TITLE'
//页面加载表示
export var UPDATE_LOADING = 'UPDATE_LOADING'
//页面切换方向
export var UPDATE_DIRECTION = 'UPDATE_DIRECTION'

//发票抬头
//新增
export var ADD_INVOICE_TITLE = 'ADD_INVOICE_TITLE'
//删除
export var DELETE_INVOICE_TITLE = 'DELETE_INVOICE_TITLE'
//修改
export var UPDATE_INVOICE_TITLE = 'UPDATE_INVOICE_TITLE'
//列表
export var LIST_INVOICE_TITLE = 'LIST_INVOICE_TITLE'

//发票
//新增
export var ADD_INVOICE = 'ADD_INVOICE'
//删除
export var DELETE_INVOICE = 'DELETE_INVOICE'
//修改
export var UPDATE_INVOICE = 'UPDATE_INVOICE'
//分页列表
export var PAGELIST_INVOICE = 'PAGELIST_INVOICE'

//更新发票影像的标签列表
export var UPDATE_INVOICE_TAGS = 'UPDATE_INVOICE_TAGS'

//设置发票影像详情
export var SET_INVOICE_INFO = 'SET_INVOICE_INFO'

//设置发票影像列表是否刷新  刷新机制有2种     1、更新某一条；2刷新整个列表
export var SET_INVOICE_INDEX_RELOAD = 'SET_INVOICE_INDEX_RELOAD'


// export const



// WEBPACK FOOTER //
// ./src/store/mutation-types.js